"use strict";

exports.__esModule = true;
exports.directionClasses = exports.default = exports.DIRECTION = void 0;
var _consts = require("../../utils/mediaQuery/consts");
let DIRECTION = /*#__PURE__*/function (DIRECTION) {
  DIRECTION["ROW"] = "row";
  DIRECTION["COLUMN"] = "column";
  DIRECTION["ROW_REVERSE"] = "row-reverse";
  DIRECTION["COLUMN_REVERSE"] = "column-reverse";
  return DIRECTION;
}({});
exports.DIRECTION = DIRECTION;
const directionClasses = {
  [DIRECTION.ROW]: "flex-row",
  [DIRECTION.COLUMN]: "flex-col",
  [DIRECTION.ROW_REVERSE]: "flex-row-reverse",
  [DIRECTION.COLUMN_REVERSE]: "flex-col-reverse",
  [_consts.QUERIES.LARGEDESKTOP]: {
    [DIRECTION.ROW]: "ld:flex-row",
    [DIRECTION.COLUMN]: "ld:flex-col",
    [DIRECTION.ROW_REVERSE]: "ld:flex-row-reverse",
    [DIRECTION.COLUMN_REVERSE]: "ld:flex-col-reverse"
  },
  [_consts.QUERIES.DESKTOP]: {
    [DIRECTION.ROW]: "de:flex-row",
    [DIRECTION.COLUMN]: "de:flex-col",
    [DIRECTION.ROW_REVERSE]: "de:flex-row-reverse",
    [DIRECTION.COLUMN_REVERSE]: "de:flex-col-reverse"
  },
  [_consts.QUERIES.TABLET]: {
    [DIRECTION.ROW]: "tb:flex-row",
    [DIRECTION.COLUMN]: "tb:flex-col",
    [DIRECTION.ROW_REVERSE]: "tb:flex-row-reverse",
    [DIRECTION.COLUMN_REVERSE]: "tb:flex-col-reverse"
  },
  [_consts.QUERIES.LARGEMOBILE]: {
    [DIRECTION.ROW]: "lm:flex-row",
    [DIRECTION.COLUMN]: "lm:flex-col",
    [DIRECTION.ROW_REVERSE]: "lm:flex-row-reverse",
    [DIRECTION.COLUMN_REVERSE]: "lm:flex-col-reverse"
  },
  [_consts.QUERIES.MEDIUMMOBILE]: {
    [DIRECTION.ROW]: "mm:flex-row",
    [DIRECTION.COLUMN]: "mm:flex-col",
    [DIRECTION.ROW_REVERSE]: "mm:flex-row-reverse",
    [DIRECTION.COLUMN_REVERSE]: "mm:flex-col-reverse"
  }
};
exports.directionClasses = directionClasses;
const getDirectionToken = (direction, viewport) => {
  return viewport ? directionClasses[viewport][direction] : directionClasses[direction];
};
var _default = getDirectionToken;
exports.default = _default;